import { AnyAction } from "redux";
import { FindById, Update } from "../../../user";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { UsersAdapter } from "../../../../adapter/users-adapter";

export const FETCH_UPDATE_USER_REQUEST = 'FETCH_UPDATE_USER_REQUEST';
export const FETCH_UPDATE_USER_SUCCESS = 'FETCH_UPDATE_USER_SUCCESS';
export const FETCH_UPDATE_USER_FAILURE = 'FETCH_UPDATE_USER_FAILURE';
export const SET_UPDATE_USER = 'SET_UPDATE_USER';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateUserRequest = () => {
    return {
        type: FETCH_UPDATE_USER_REQUEST,
    };
};

const fetchUpdateUserSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_USER_SUCCESS,
        payload: data
    };
};

const fetchUpdateUserFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_USER_FAILURE,
        payload: error,
    };
};

export const setUpdateUser = (data: any) => {
    return {
        type: SET_UPDATE_USER,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateUserRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateUserSuccess(
                Adapter.from(response.data).to((value) => new UsersAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateUserFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateUserRequest());
        try {
            const response = await FindById(id, "fields=*.*");

            console.log("RESPONSE", response);

            dispatch(setUpdateUser(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateUserFailure(error.message));
        }
    };
};
